export type TravelPeriodStateManagerType = {
    arrivalDate: Date | null;
    departureDate: Date | null;
};

export enum SelectedState {
    ARRIVAL = 'arrival',
    DEPARTURE = 'departure'
}
